var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"25.9459","height":"2.16216","rx":"1.08108","fill":"black","key":0}),React.createElement("rect",{"y":"6.91895","width":"19.8919","height":"2.16216","rx":"1.08108","fill":"black","key":1}),React.createElement("rect",{"y":"13.8379","width":"12.973","height":"2.16216","rx":"1.08108","fill":"black","key":2})]);
}

Arrow.defaultProps = {"width":"26","height":"16","viewBox":"0 0 26 16","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
